export type DataObjectValueType = unknown;

export type DataObject = { [key in string]?: DataObjectValueType };

export type Data = DataObject | DataObjectValueType | null;

export interface ExpEvalRequest {
  expression: string;
  data: Data;
  variables: DataObject;
}

export interface ExpEvalResult {
  value: Data;
}

export enum ExpressionLanguage {
  SPEL = 'SPEL',
  JEXL = 'JEXL',
}

export interface ExpService {
  evaluate(request: ExpEvalRequest): ExpEvalResult;
}

export interface ExpressionBuilder {
  indexReplacement(idxVar: string): string;
  resolveAttributePath(attribute: string): string;
  sizeOf(attribute: string): string;
}

class ExpServiceProvider {
  private static instance: ExpServiceProvider;

  private expService?: ExpService;
  private expressionBuilder?: ExpressionBuilder;

  private constructor() {}

  static getInstance(): ExpServiceProvider {
    if (!ExpServiceProvider.instance) {
      ExpServiceProvider.instance = new ExpServiceProvider();
    }
    return ExpServiceProvider.instance;
  }

  getExpService = (): ExpService => {
    if (!this.expService) {
      throw new Error(`[ExpService] is not initialized`);
    }
    return this.expService;
  };

  setExpService = (expService?: ExpService): void => {
    this.expService = expService;
  };

  getExpressionBuilder = (): ExpressionBuilder => {
    if (!this.expressionBuilder) {
      throw new Error(`[ExpressionBuilder] is not initialized`);
    }
    return this.expressionBuilder;
  };

  setExpressionBuilder = (expressionBuilder?: ExpressionBuilder): void => {
    this.expressionBuilder = expressionBuilder;
  };
}

const expServiceProvider = ExpServiceProvider.getInstance();

export default expServiceProvider;
